<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { InsertLink } from "ls/common/keyboardShortcuts";
import { Link2Icon } from "lucide-vue-next";
import { useRichTextContext } from "../context";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

const { toggleUpdateLinkOpen } = useRichTextContext();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .run();

  toggleUpdateLinkOpen(true);
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="Link2Icon"
    :shortcut="InsertLink"
    @pointerdown.prevent
    @click="run"
    @keydown.enter="run"
  >
    Link
  </SuggestionListItem>
</template>
